import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

interface GetAdminQuestionnaireResponseParams {
  questionnaire: string;
  author?: string;
  source?: string;
  sort?: string;
}

export async function GetAdminQuestionnaireResponse({
  questionnaire,
  author,
  source,
  sort,
}: GetAdminQuestionnaireResponseParams) {
  let url = `${endpoints.ADMFHIR}/QuestionnaireResponse?questionnaire=${questionnaire}&_count=150`;

  if (author) {
    url += `&author=Organization/${author}`;
  }
  if (source) {
    url += `&source=${source}`;
  }
  if (sort) {
    url += `&_sort=${sort}`;
  }

  const bearerToken = await useAuth.getUserToken();
  const headers = {
    Accept: "*/*",
    Authorization: bearerToken,
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .get(url, { headers, timeout: 8000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetAdminQuestionnaireResponse: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetAdminQuestionnaireResponse ", error);
      // toast.error(
      //   `GetAdminQuestionnaireResponse Error: ${error?.response?.status}`
      // );
      throw new Error(
        `Erro ao buscar QuestionnaireResponse: ${
          error.message || "Erro desconhecido"
        }`
      );
    });
  if (response) return response;
}
